import { AppShell as MAppShell } from "@mantine/core";
import { Outlet } from "react-router-dom";
import { Header } from "./Header.js";
import { Sidebar } from "./Sidebar.js";

export function AppShell() {
  return (
    <MAppShell
      header={{ height: 56 }}
      navbar={{ width: 240, breakpoint: "sm" }}
      padding="md"
    >
      <MAppShell.Header><Header /></MAppShell.Header>
      <MAppShell.Navbar><Sidebar /></MAppShell.Navbar>
      <MAppShell.Main><Outlet /></MAppShell.Main>
    </MAppShell>
  );
}
